import { render } from "./App.vue?vue&type=template&id=8470659c"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=8470659c&lang=scss"

import exportComponent from "/Users/skynet/Documents/Sites Safe/Safe_Sites_Modifs/SAFE_MED/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__